import styled from 'styled-components'

export const Anchor = styled.a``

export const TextLabel = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  font-size: ${({ theme }) => theme.fontSize.xxs};
`
